import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environmentConfig } from '../../environment';

@Injectable({
  providedIn: 'root'
})
export class PfsService {
  private apiUrl = environmentConfig.apiBaseUrl;
  private mockUrl = "assets/mock_holdings.json"

  constructor(private http: HttpClient) { }

  getHoldingsByClient(clientId: number, token: any): Observable<any> {
    const url = `${this.apiUrl}/api/pfs/get_holdings_by_client?client_id=${clientId}`;
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`
    });

    return this.http.get<any>(url, { headers });
  }

  getChartConfigByClient(clientId: number, token?: any): Observable<any> {
    const url = `${this.apiUrl}/api/pfs/get_chart_config_by_client?client_id=${clientId}`;
    const headers = token ? new HttpHeaders({ 'Authorization': `Bearer ${token}` }) : undefined;
    return this.http.get<any>(url, { headers });
  }

  getChartDataByClient(clientId: number, token?: any): Observable<any[]> {
    const url = `${this.apiUrl}/api/pfs/get_chart_data_by_client?client_id=${clientId}`;
    const headers = token ? new HttpHeaders({ 'Authorization': `Bearer ${token}` }) : undefined;
    return this.http.get<any[]>(url, { headers });
  }

  getChartDataByMetadata(clientId: number, dataSet: string, xColumn: string, yColumn: string, token?: any ): Observable<any[]> {
    const url = `${this.apiUrl}/api/pfs/get_chart_data_by_metadata` +
      `?client_id=${clientId}&data_set=${encodeURIComponent(dataSet)}` +
      `&x_column=${encodeURIComponent(xColumn)}&y_column=${encodeURIComponent(yColumn)}`;

    const headers = token
      ? new HttpHeaders({ 'Authorization': `Bearer ${token}` })
      : undefined;

    return this.http.get<any[]>(url, { headers });
  }
  
  getQBInterCompanyRecord(clientID: string, entityA: string, entityB: string): Promise<any> {
    const url = `${this.apiUrl}/api/qb/my_intermapping?cli=${clientID}&enta=${entityA}&entb=${entityB}`;
    const response: any = this.http.get(url).toPromise();
    return response;
  }
}
